import Accordion from './Accordion';
import AccordionItem from './AccordionItem';

export { Accordion, AccordionItem };
export default Accordion;


// WEBPACK FOOTER //
// ./src/components/UI/Accordion/index.js